<template>
  <div class="content-v2">
    <BreadcrumbV2 :items="breadcrumbItems" />
    <div class="detail-v2">
      <div class="detail-img-v2">
        <img :src="star.image" :alt="star.name" />
      </div>
      <div class="detail-info-v2">
        <h2>{{ star.name }}</h2>
        <div class="info-tags">
          <span>{{ star.dept }}</span>
          <span>{{ star.position }}</span>
        </div>
        <div class="info-desc" v-html="star.desc"></div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadcrumbV2 from '@/components/BreadcrumbV2.vue'
import { getCultureArticleDetail } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'
import defaultStarImage from '@/assets/images/staff1.svg'

export default {
  name: 'StarsDetailV2',
  components: { BreadcrumbV2 },
  data() {
    return {
      breadcrumbItems: [
        { nameKey: 'common.enterprise', path: '/enterprise' },
        { nameKey: 'common.stars', path: '/enterprise/stars' }
      ],
      star: {
        name: '优秀员工',
        dept: '工程技术部',
        position: '项目经理',
        image: defaultStarImage,
        desc: '该员工在工作中表现突出，多次获得公司表彰。在多个重大项目中担任核心角色，带领团队攻坚克难，确保了项目的顺利交付。'
      }
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(id) {
        this.star.name = '优秀员工 ' + id
        this.loadDetail()
      }
    }
  },
  methods: {
    loadDetail() {
      const id = this.$route.params.id
      if (!id) {
        return
      }
      getCultureArticleDetail(id).then(data => {
        if (!data || !data.articleId) {
          return
        }
        this.star = {
          name: data.articleTitle,
          dept: '盛博莱之星',
          position: data.publishDate || '',
          image: resolveFileUrl(data.coverUrl, defaultStarImage),
          desc: data.articleContent || data.summary || ''
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-v2 {
  display: flex;
  gap: 50px;
  background: #fff;
  border-radius: 24px;
  padding: 50px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.06);

  .detail-img-v2 {
    width: 320px;
    flex-shrink: 0;
    border-radius: 20px;
    overflow: hidden;

    img {
      width: 100%;
      display: block;
    }
  }

  .detail-info-v2 {
    flex: 1;

    h2 {
      font-size: 32px;
      font-weight: 700;
      color: #0f172a;
      margin-bottom: 20px;
    }

    .info-tags {
      display: flex;
      gap: 10px;
      margin-bottom: 24px;

      span {
        padding: 8px 20px;
        background: #f1f5f9;
        color: #3b82f6;
        font-size: 14px;
        font-weight: 600;
        border-radius: 20px;
      }
    }

    .info-desc {
      font-size: 17px;
      line-height: 2;
      color: #475569;
      text-indent: 2em;

      ::v-deep p {
        margin-bottom: 16px;
      }
    }
  }
}

@media (max-width: 960px) {
  .detail-v2 {
    flex-direction: column;

    .detail-img-v2 {
      width: 100%;
      max-width: 400px;
    }
  }
}
</style>
